<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Manage Portfolio Accounts & Direct Indexing
      </p>
      <button
        type="button"
        class="delete"
        v-on:click="$parent.close"
      />
    </header>
    <div class="modal-card-body" v-if="portfolio.id">
      <AccountSetupFlow
        v-if="dndxSetup"
        v-bind:portfolio="portfolio"
        v-bind:callback="completeDndxFlow"
      />

      <b-table
        v-if="!dndxSetup"

        v-bind:data="displayRows"
        card-layout
      >
        <b-table-column
          field="name"
          label="Name"
          v-slot="props"
        >
          {{ props.row.name }}
        </b-table-column>
        <b-table-column
          label="Direct Indexing"
          v-slot="props"
        >
          <div>
            <template v-if="props.row.metadata.fafn_dndx && props.row.metadata.fafn_dndx.enabled">
              <span>✅ <strong class="has-text-success">Enabled</strong></span>
              &nbsp;&nbsp;
              <a
                class="button is-small is-info"
                v-bind:href="companyScreenerLink(props.row)" target="_blank"
              >
                Review Screens
              </a>
            </template>
            <template v-else>
              <button
                class="button is-small is-primary"
                v-on:click="startDndxFlow"
              >
                Enable
              </button>
            </template>
          </div>
        </b-table-column>

        <!-- Room for action buttons (generate report, view in x tool etc)
        <b-table-column
          v-slot="props"
          cell-class="is-justify-content-flex-end"
        >
        </b-table-column> -->
      </b-table>
    </div>
    <div class="modal-card-foot has-text-right is-justify-content-flex-end">
    </div>
  </div>
</template>

<script>
  import AccountSetupFlow from '@frontend/dash3/js/components/portfolios/AccountSetupFlow.vue';

  export default {
    data() {
      return {
        portfolio: {},

        dndxSetup: false,
        benchmarkPortfolioName: null,
      }
    },
    components: {
      AccountSetupFlow,
    },
    props: {
      portfolioId: String,
    },
    methods: {
      startDndxFlow: function() {
        this.dndxSetup = true;
      },
      completeDndxFlow: function() {
        this.dndxSetup = false;
        this.$buefy.dialog.alert(
          'Direct indexing successfully enabled for this client. You will receive a confirmation email shortly.'
        );
      },
      companyScreenerLink: function(account) {
        let params = {
          values_from: this.portfolioId,
          account: account.id,
        }
        let nonPersonaScreenSets = this.portfolio.screen_sets.filter((itm) => { return itm.is_template === false && !itm.internal_identifier});
        if (nonPersonaScreenSets.length > 0) {
          params.screen_set = nonPersonaScreenSets[0].id;
        }
        params.universe_portfolio_name = "VADIS Default Universe";
        return `/advisordashboard/portfolio-builder/?${new URLSearchParams(params)}`;
      }

    },
    computed: {
      displayRows: function() {
        if (this.portfolio.accounts && this.portfolio.accounts.length > 0) {
          return this.portfolio.accounts;
        }
        else {
          return [this.portfolio]; // galaxy brain duck typing
        }
      }
    },
    created: function() {
    },
    mounted: async function() {
      let pathName = this.portfolioId.indexOf('shareowner_') === 0 ? 'portfolios' : 'prospects';
      let response = await fetch(`/api/v1/${pathName}/${this.portfolioId}/`);
      let data = await response.json();
      this.portfolio = pathName === 'portfolios' ? data.portfolio : data.prospect;
    }
  }
</script>

<style lang="scss" scoped>
</style>
